import { render, staticRenderFns } from "./AssetReference.vue?vue&type=template&id=ad78b2e8"
import script from "./AssetReference.vue?vue&type=script&lang=js"
export * from "./AssetReference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports